import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import { useTranslation } from 'react-i18next';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/free-mode';

import amountDollar from '../../../assets/assets-homepage/img/icons/lsicon_amount-dollar-outline.svg';
import handDeposit from '../../../assets/assets-homepage/img/icons/ph_hand-deposit.svg';
import usersFour from '../../../assets/assets-homepage/img/icons/ph_users-four.svg';
import SpeakToExpertButton from 'src/components/home/SpeakToExpertButton';

const BecomeClient = ({ price = 10000 }: { price?: number }) => {
  const { t, i18n } = useTranslation('home');
  const isRu = i18n.language === 'ru'
  const formattedPrice = Number(price).toLocaleString('en-US');
  const slides = [
    { img: amountDollar, text: t('becomeClient.slides.minBooking', { amount: formattedPrice }) },
    { img: handDeposit, text: t('becomeClient.slides.deposit', { amount: formattedPrice }) },
    { img: usersFour, text: t('becomeClient.slides.referral') },
  ];

  return <>
    <div className='py-8 sm:py-10 lg:py-[60px]'>
      <div className="become !py-8 sm:!py-10 lg:!py-[60px] !px-0" id="become">
        <div className="max-w-[1600px] mx-auto lg:px-10">
          <h2 className="section-heading text-center text-white mb-5 sm:mb-8 lg:mb-11">{t('becomeClient.heading')}</h2>
          <Swiper
            modules={[Pagination]}
            pagination={{ clickable: true, el: '.become_pagination', }}
            breakpoints={{
              0: { slidesPerView: 'auto', spaceBetween: 30, slidesOffsetBefore: 20, slidesOffsetAfter: 20 },
              640: { slidesPerView: 'auto', spaceBetween: 63, slidesOffsetBefore: 24, slidesOffsetAfter: 60 },
              992: { slidesPerView: 'auto', spaceBetween: 43, slidesOffsetBefore: 32, slidesOffsetAfter: 32 },
              1100: { slidesPerView: 3, spaceBetween: 76, slidesOffsetBefore: 0, slidesOffsetAfter: 0 },
            }}
            className="become_slider"
          >
            {slides.map((slide, index) => (
              <SwiperSlide key={index} className='w-full sm:max-w-[453px] max-w-[233px]'>
                <div className="become_item_wrp w-full">
                  <div className="become_item">
                    <div className="become_item__img">
                      <img src={slide.img} alt="" />
                    </div>

                    <h6 className={`text-black ${isRu ? 'text-xs sm:text-[22px] leading-tight' : 'font-medium text-xs sm:text-base'} text-center`}>{slide.text}</h6>
                  </div>
                </div>
              </SwiperSlide>
            ))}
            <div className="pagination become_pagination"></div>
          </Swiper>

          <p className="become_p hidden lg:block !mt-3 !text-lg">{t('becomeClient.tagline')}</p>
        </div>
      </div>

      <div className="flex justify-center mt-6  sm:mt-8">
        <SpeakToExpertButton />
      </div>
    </div>
  </>

};

export default BecomeClient;
